import React, { memo, useCallback } from 'react';
import { Link } from 'react-router-dom';
import TopSearch from "../blocks/Main/Search/TopSearch";

//import Components
import FullScreenDropdown from '../components/Common/FullScreenDropdown';
import NotificationDropdown from '../components/Common/NotificationDropdown';
import ProfileDropdown from '../components/Common/ProfileDropdown';
import LightDark from '../components/Common/LightDark';
import LangSwitch from "../components/LangSwitch";
import CabinetDropdown from "../components/Common/CabinetDropdown";
import PlanDropdown from "../components/Common/PlanDropdown";
import CompareChannelsTop from "../components/CompareChannelsTop";

//import images
const logoSm = require("../resources/images/mcLogoCircle.svg");
const logoDark = require("../resources/images/mclogo.svg");
const logoLight = require("../resources/images/mclogow.svg");

interface HeaderProps {
    onChangeLayoutMode: (mode: string) => void;
    layoutModeType: string;
    headerClass: string;
}

const Header = memo(({ onChangeLayoutMode, layoutModeType, headerClass }: HeaderProps) => {
    const toogleMenuBtn = useCallback(() => {
        var windowSize = document.documentElement.clientWidth;

        if (windowSize > 767)
            document.querySelector(".hamburger-icon").classList.toggle('open');

        //For collapse horizontal menu
        if (document.documentElement.getAttribute('data-layout') === "horizontal") {
            document.body.classList.contains("menu") ? document.body.classList.remove("menu") : document.body.classList.add("menu");
        }

        //For collapse vertical menu
        if (document.documentElement.getAttribute('data-layout') === "vertical") {
            if (windowSize < 1025 && windowSize > 767) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'sm') ? document.documentElement.setAttribute('data-sidebar-size', '') : document.documentElement.setAttribute('data-sidebar-size', 'sm');
            } else if (windowSize > 1025) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'lg') ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg');
            } else if (windowSize <= 767) {
                document.body.classList.add('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
        }

        //Two column menu
        if (document.documentElement.getAttribute('data-layout') === "twocolumn") {
            document.body.classList.contains('twocolumn-panel') ? document.body.classList.remove('twocolumn-panel') : document.body.classList.add('twocolumn-panel');
        }
    }, []);

    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">

                            <div className="navbar-brand-box horizontal-logo">
                                <Link to="/" className="logo logo-dark">
                                    <span className="logo-sm">
                                        <img src={logoSm.default} alt="" height="22" />
                                    </span>
                                    <span className="logo-lg">
                                        <img src={logoDark.default} alt="" height="17" />
                                    </span>
                                </Link>

                                <Link to="/" className="logo logo-light">
                                    <span className="logo-sm">
                                        <img src={logoSm.default} alt="" height="22" />
                                    </span>
                                    <span className="logo-lg">
                                        <img src={logoLight.default} alt="" height="17" />
                                    </span>
                                </Link>
                            </div>

                            <button
                                onClick={toogleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                                id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span/>
                                    <span/>
                                    <span/>
                                </span>
                            </button>

<TopSearch/>

                        </div>

                        <div className="d-flex align-items-center">

                            <PlanDropdown/>

                            <LangSwitch/>

                            <FullScreenDropdown />

                            <LightDark
                                layoutMode={layoutModeType}
                                onChangeLayoutMode={onChangeLayoutMode}
                            />
                            <CompareChannelsTop/>
                            <CabinetDropdown/>
                            <NotificationDropdown/>
                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
});

Header.displayName = 'Header';

export default Header;